import mifosRepository, { MifosRepository } from "./MifosRepository";

const resource = "/offices";
const APPLICATION_JSON = "application/json";

export default {
  getAllOffices() {
    mifosRepository.setContentType(APPLICATION_JSON);
    return MifosRepository.get(resource);
  }
}
